<template>
<div>
  <b-container fluid class="bg-white">
    <b-row cols="2">
      <b-col>
        <div class="mb-4" v-for="chart in barCharts1" :key="chart.key">
          <bar-stacked-simple v-if="Array.isArray(chart.data) && chart.data.length > 0" :config="chart"/>
        </div>
      </b-col>
      <b-col>
        <div class="mb-4" v-for="chart in barCharts2" :key="chart.key">
          <bar-stacked-simple v-if="Array.isArray(chart.data) && chart.data.length > 0" :config="chart"/>
        </div>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import _ from 'lodash'
import * as echarts from 'echarts'
import dataGetters from '@/libs/dataGetters'
import theme from '@/libs/colorTheme'
import workflows from '@/workflows/initiative'
import BarStackedSimple from '@/components/charts/v1/barStackedSimple.vue'
echarts.registerTheme('kpmg', theme)

function getHeight (data) {
  return (Math.floor(data.length / 10) + 1) * 140 + 'px'
}

function getRandomKey () {
  return Math.floor(Math.random() * 10000)
}

export default {
  name: 'DataStrats',
  components: {
    BarStackedSimple
  },
  computed: {
    barCharts1: function () {
      const results = []
      const charts = [
        {
          dataGetter: 'property',
          property: 'country',
          nameProperty: 'name',
          nameSeries: 'Initiatives',
          header: 'Initiatives per country',
          headerRecord: 'countries'
        }
      ]
      _.each(charts, chart => {
        const data = dataGetters[chart.dataGetter](this.rows, chart)
        const config = {
          data: data,
          name: chart.nameSeries,
          header: chart.header,
          headerRecord: chart.headerRecord,
          height: getHeight(data),
          width: '100%',
          key: getRandomKey()
        }
        results.push(config)
      })
      return results
    },
    barCharts2: function () {
      const results = []
      const charts = [
        {
          dataGetter: 'object',
          property: 'impactpolicy',
          nameProperty: 'name',
          nameSeries: 'Policies',
          header: 'Policies',
          headerRecord: 'policies'
        },
        {
          dataGetter: 'array',
          property: 'regulators',
          nameProperty: 'name',
          nameSeries: 'Initiatives',
          header: 'Initiatives per regulator',
          headerRecord: 'regulators'
        },
        {
          dataGetter: 'array',
          property: 'impacttopics',
          nameProperty: 'name',
          nameSeries: 'Initiatives',
          header: 'Initiatives per topic',
          headerRecord: 'topics'
        },
        {
          dataGetter: 'object',
          property: 'impactstatus',
          nameProperty: 'name',
          nameSeries: 'Initiatives',
          header: 'Initiatives per status',
          headerRecord: 'statuses'
        },
        {
          dataGetter: 'workflow',
          workflows: workflows,
          property: 'workflow_id',
          nameProperty: 'name',
          nameSeries: 'Initiatives',
          header: 'Initiatives per workflow stage',
          headerRecord: 'stages'
        }
      ]
      _.each(charts, chart => {
        const data = dataGetters[chart.dataGetter](this.rows, chart)
        const config = {
          data: data,
          name: chart.nameSeries,
          header: chart.header,
          headerRecord: chart.headerRecord,
          height: getHeight(data),
          width: '100%',
          key: getRandomKey()
        }
        results.push(config)
      })
      return results
    },
    rows: function () {
      return this.$store.state.initiativesPolicies
    },
    user: {
      get () {
        return this.$store.state.user
      }
    }
  },
  created: function () {
    document.title = "Climate Policy and Regulatory Dashboard - Data stratification"
  }
}
</script>

<style>
</style>
